import {connect} from '@modifi/redux'

import {ApplicationContextProvider, CHARON_TRANSLATION_KEY_FIXES} from '@modifi/plugin-onboarding'

import {selectCurrentCompaniesCountryCodeLowerCased} from '../../data/company'

const mapStateToProps = (
  state: Record<string, any>
): {
  currentCountryCode: string | null
  translationKeyFixes: Record<string, (k: string) => string>
} => ({
  currentCountryCode: selectCurrentCompaniesCountryCodeLowerCased(state),
  translationKeyFixes: CHARON_TRANSLATION_KEY_FIXES,
})

const mapDispatchToProps = {}

export default connect(mapStateToProps, mapDispatchToProps)(ApplicationContextProvider)
